import { FC } from 'react';
import { useTheme } from 'styled-components';
import styled from 'styled-components';

import { EditorialFacebookPostType } from '@/utils/enums';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > svg {
    color: ${({ theme }) => theme.colors.gray};
  }
`;

interface Props {
  type: EditorialFacebookPostType;
}

const PostType: FC<Props> = ({ type }) => {
  const theme = useTheme();

  switch (type) {
    case EditorialFacebookPostType.IMAGE:
      return (
        <Wrap>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="14" height="14" fill={theme.colors.grayscaleLight} />
            <path
              d="M11.8125 2.625H2.1875C1.94588 2.625 1.75 2.82088 1.75 3.0625V10.9375C1.75 11.1791 1.94588 11.375 2.1875 11.375H11.8125C12.0541 11.375 12.25 11.1791 12.25 10.9375V3.0625C12.25 2.82088 12.0541 2.625 11.8125 2.625Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.75 9.18791L4.50313 6.43478C4.54376 6.39416 4.59199 6.36193 4.64507 6.33994C4.69815 6.31796 4.75504 6.30664 4.81249 6.30664C4.86995 6.30664 4.92684 6.31796 4.97992 6.33994C5.033 6.36193 5.08123 6.39416 5.12185 6.43478L7.56563 8.87856C7.60626 8.91919 7.65449 8.95141 7.70757 8.9734C7.76065 8.99539 7.81754 9.0067 7.87499 9.0067C7.93245 9.0067 7.98934 8.99539 8.04242 8.9734C8.0955 8.95141 8.14373 8.91919 8.18435 8.87856L9.31563 7.74728C9.35626 7.70666 9.40449 7.67443 9.45757 7.65244C9.51065 7.63046 9.56754 7.61914 9.62499 7.61914C9.68245 7.61914 9.73934 7.63046 9.79242 7.65244C9.8455 7.67443 9.89373 7.70666 9.93435 7.74728L12.25 10.0629"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.53125 6.125C8.89369 6.125 9.1875 5.83119 9.1875 5.46875C9.1875 5.10631 8.89369 4.8125 8.53125 4.8125C8.16881 4.8125 7.875 5.10631 7.875 5.46875C7.875 5.83119 8.16881 6.125 8.53125 6.125Z"
              fill="currentColor"
            />
          </svg>
          Image
        </Wrap>
      );
    case EditorialFacebookPostType.VIDEO:
      return (
        <Wrap>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="14" height="14" fill={theme.colors.grayscaleLight} />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.66667 3.5H2.33333C2.1028 3.5 1.88791 3.59723 1.73412 3.76006C1.58125 3.92193 1.5 4.13566 1.5 4.35294V8.58824C1.5 9.08634 1.68661 9.56938 2.02702 9.92982C2.36834 10.2912 2.83758 10.5 3.33333 10.5H8.66667C8.8972 10.5 9.11209 10.4028 9.26588 10.2399C9.41875 10.0781 9.5 9.86434 9.5 9.64706V8.43605L11.7969 9.45691C11.9516 9.52565 12.1305 9.51148 12.2725 9.41925C12.4144 9.32702 12.5 9.16925 12.5 9V5C12.5 4.83075 12.4144 4.67298 12.2725 4.58075C12.1305 4.48853 11.9516 4.47435 11.7969 4.54309L9.5 5.56395V5.41176C9.5 4.91366 9.31339 4.43061 8.97298 4.07018C8.63166 3.70878 8.16242 3.5 7.66667 3.5ZM8.5 6.32247C8.49983 6.32988 8.49983 6.33731 8.5 6.34475V7.65525C8.49983 7.66269 8.49983 7.67012 8.5 7.67754V9.5H3.33333C3.12184 9.5 2.91281 9.41131 2.75403 9.24319C2.59434 9.07411 2.5 8.83898 2.5 8.58824V4.5H7.66667C7.87816 4.5 8.08719 4.58869 8.24597 4.75681C8.40566 4.92589 8.5 5.16102 8.5 5.41176V6.32247ZM9.5 7.34173V6.65827L11.5 5.76938V8.23062L9.5 7.34173Z"
              fill="currentColor"
            />
          </svg>
          Video
        </Wrap>
      );
    case EditorialFacebookPostType.REEL:
      return (
        <Wrap>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="14"
              height="14"
              transform="translate(1 1)"
              fill={theme.colors.grayscaleLight}
            />
            <path
              d="M10 8L7 6V10L10 8Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              x="2.5"
              y="2.5"
              width="11"
              height="11"
              rx="2.5"
              stroke="currentColor"
            />
          </svg>
          Reel
        </Wrap>
      );
    case EditorialFacebookPostType.PLACEHOLDER:
      return <Wrap>Placeholder</Wrap>;
    case EditorialFacebookPostType.STORY:
      return (
        <Wrap>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="14" height="14" fill={theme.colors.grayscaleLight} />
            <path
              d="M11.231 11.286V2.71456C11.231 2.24118 10.8521 1.85742 10.3848 1.85742L3.61557 1.85742C3.14825 1.85742 2.76942 2.24118 2.76942 2.71456V11.286C2.76942 11.7594 3.14825 12.1431 3.61557 12.1431H10.3848C10.8521 12.1431 11.231 11.7594 11.231 11.286Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.30762 3.57227H8.69223"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Story
        </Wrap>
      );
    case EditorialFacebookPostType.TEXT:
      return (
        <Wrap>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="14" height="14" fill={theme.colors.grayscaleLight} />
            <path
              d="M7 3V11"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3 5V3H11V5"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 11H9"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Text
        </Wrap>
      );
    case EditorialFacebookPostType.IMAGE_ALBUM:
      return (
        <Wrap>
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.1667 3.5H3.83333C3.64924 3.5 3.5 3.67909 3.5 3.9V11.1C3.5 11.3209 3.64924 11.5 3.83333 11.5H11.1667C11.3508 11.5 11.5 11.3209 11.5 11.1V3.9C11.5 3.67909 11.3508 3.5 11.1667 3.5Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.5 10L5.77161 8.18272C5.90763 8.0739 6.09843 8.06562 6.24336 8.16224L8.78938 9.85959C8.918 9.94533 9.08451 9.94929 9.21706 9.86976L11.5 8.5"
              stroke="currentColor"
            />
            <path
              d="M8.5 3.5V0.9C8.5 0.679086 8.32091 0.5 8.1 0.5H0.9C0.679086 0.5 0.5 0.679086 0.5 0.9V8.1C0.5 8.32091 0.679086 8.5 0.9 8.5H3.5"
              stroke="currentColor"
            />
            <path
              d="M8.65625 6.8125C9.01869 6.8125 9.3125 6.51869 9.3125 6.15625C9.3125 5.79381 9.01869 5.5 8.65625 5.5C8.29381 5.5 8 5.79381 8 6.15625C8 6.51869 8.29381 6.8125 8.65625 6.8125Z"
              fill="currentColor"
            />
          </svg>
          Image Album
        </Wrap>
      );
    case EditorialFacebookPostType.LINK:
      return (
        <Wrap>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="14" height="14" fill={theme.colors.grayscaleLight} />
            <path
              d="M5.69531 8.30617L8.30617 5.69531"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.65328 8.95851L6.56542 10.0464C6.21918 10.3925 5.74963 10.5869 5.26006 10.5869C4.77048 10.5868 4.30097 10.3923 3.95479 10.0461C3.60861 9.69996 3.4141 9.23045 3.41406 8.74087C3.41402 8.2513 3.60844 7.78175 3.95457 7.43551L5.04242 6.34766"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.95851 7.65328L10.0464 6.56542C10.3925 6.21918 10.5869 5.74963 10.5869 5.26006C10.5868 4.77048 10.3923 4.30097 10.0461 3.95479C9.69996 3.60861 9.23045 3.4141 8.74088 3.41406C8.2513 3.41402 7.78176 3.60844 7.43551 3.95456L6.34766 5.04242"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Link
        </Wrap>
      );
    case EditorialFacebookPostType.SHARE:
      return (
        <Wrap>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="14" height="14" fill={theme.colors.grayscaleLight} />
            <path
              d="M5.69531 8.30617L8.30617 5.69531"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.65328 8.95851L6.56542 10.0464C6.21918 10.3925 5.74963 10.5869 5.26006 10.5869C4.77048 10.5868 4.30097 10.3923 3.95479 10.0461C3.60861 9.69996 3.4141 9.23045 3.41406 8.74087C3.41402 8.2513 3.60844 7.78175 3.95457 7.43551L5.04242 6.34766"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.95851 7.65328L10.0464 6.56542C10.3925 6.21918 10.5869 5.74963 10.5869 5.26006C10.5868 4.77048 10.3923 4.30097 10.0461 3.95479C9.69996 3.60861 9.23045 3.4141 8.74088 3.41406C8.2513 3.41402 7.78176 3.60844 7.43551 3.95456L6.34766 5.04242"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Share
        </Wrap>
      );
    default:
      return <Wrap>UNKNOWN</Wrap>;
  }
};

export default PostType;
